module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Pen-tool-vector-33ecb681f3af2ec1adbd87be8b888bd2.svg";